<template>
<div>

<div  class="modal" id="modalEpsonSingleUseVoucher"tabindex="-1" data-backdrop="static" data-keyboard="false" >
<div class="modal-dialog modal-dialog-centered"> 


<div  class="modal-content border border-success">

<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA GESTIONALE COUPON EMESSO</strong>
  </h4>  
</div>


<div  v-if="fiscalPrinter.fpId"  class="modal-body border border-success">
  <span style="color:red" v-if="msg.title"> {{ msg.body }}</span>

  <!--<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>-->
</div>
<div v-else class="modal-body border border-success">
    <div class="d-flex justify-content-center">
  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>




</div>



<div class="modal-footer">
 
     <button @click="closeModal()" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button v-if="fiscalPrinter.fpId==1" @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    

    

</div>
</div>




</div>
</div>
</div>

</template>

<script>

import { mapGetters } from 'vuex';

import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'

import fmt               from '@/components/mixins/fmt'


  export default {
  mixins : [fmt],
  props  : ['coupon'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
        
          deskId      : 1,  
          items       : [],
        
          bt_spinner  : false,
        
          fiscalPrinter : {}
                                   
      }
    },
    computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
      
    created () 
      {
        const deskId = JSON.parse(localStorage.getItem("deskId"))    
        if(deskId)
        {    
            this.deskId = Number(deskId)
    
        }
        this.$nextTick(()  => {                  
            $('#modalEpsonSingleUseVoucher').modal('show')
        
            })   
        
        
        this.getFiscalPrinter()        
      },
    
    methods: 
    {
    
    async getFiscalPrinter()
    {
    

    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId':this.storeId,'deskId':this.deskId}      
    const json  = Object.assign(data, sp)
      
      //this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            this.fiscalPrinter = res.data.recordsets[0][0]
            
         }
         
        }
        else if(res.status==500)
        {
         
     
        
        } 
        else
        {
          
        
        } 
    }).catch(err => 
    {
      
     
       
    }).finally(() => {
      
    });

  

   },

    closeModal()
    {
        $('#modalEpsonSingleUseVoucher').modal('hide')
        this.$nextTick(()  => {              
        this.$emit('close')        
    })    
    },  

     getXML() 
     {
        
        let xml = ''                      
        xml = '<printerNonFiscal><beginNonFiscal  operator="1"/>'        
        xml += '<printNormal operator="1" font="2" data="COUPON EURO ' + this.fmt1(this.coupon.total) + '" justification = "1" />'            
        xml += '<printNormal operator="1" font="1" data="SCADENZA ' + this.coupon.expire_at + '" justification = "1" />'            
        xml += '<printNormal operator="1" font="1" data=" " justification = "1" />'            
        xml += '<printNormal operator="1" font="1" data=" " justification = "1" />'            
        xml += '<printBarCode operator="1" position="901" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="67" code="' + this.coupon.barcode + '"/>'         
        xml += '<endNonFiscal  operator="1" /></printerNonFiscal>'
          
          console.log('EPSON NON FISCAL VOUCHER ',xml)  
          return xml              
      },
   
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      
      
      postXML()      
      {   

          this.msg.title = ''
          this.bt_spinner = true
          const url = this.fiscalPrinter.url
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('RT Response',res)
                this.closeModal()
                
             }).catch(err => {
                
                this.bt_spinner   = false   
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          

               console.log('Errore Fiscal Printer ',err)  
             })
       
      }, 

      
         
   
     } 
      

    
  }
</script>
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
.form-check-label
{
  cursor: pointer;
}

</style>
